// Paid Tables Outbox - local list of paid table transactions for UI visibility

const STORAGE_KEY = 'paid_tables_outbox_v1';
const MAX_ITEMS = 500;

function readAll() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        console.warn('[PaidTablesOutbox] Failed to read storage', e);
        return [];
    }
}

function writeAll(items) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
        console.warn('[PaidTablesOutbox] Failed to write storage', e);
    }
}

export async function getAllPaidTables() {
    return readAll();
}

export async function addPaidTable(entry) {
    if (!entry) return;
    const items = readAll();

    const saleNumber = entry.saleNumber != null ? String(entry.saleNumber) : '';
    if (!saleNumber) return;

    // De-duplicate by saleNumber; keep latest
    const filtered = items.filter(i => String(i.saleNumber) !== saleNumber);
    filtered.unshift({
        ...entry,
        saleNumber,
        paidAt: entry.paidAt || new Date().toISOString()
    });

    if (filtered.length > MAX_ITEMS) {
        filtered.length = MAX_ITEMS;
    }
    writeAll(filtered);
}

export async function clearPaidTables() {
    writeAll([]);
}

export default {
    getAllPaidTables,
    addPaidTable,
    clearPaidTables
};
